// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1a782eee8c7a1d21f3fd736a89c8bcdb531c7f3c/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};